import { PageLayout } from "@/components/layouts/PageLayout";
import { useAppContext } from "@/modules/app";
import { useIntl } from "react-intl";
import { Navigate } from "react-router-dom";
import Balance from "./containers/Balance";

export default function BalancePage() {
  const { user } = useAppContext();
  const intl = useIntl();

  if (!user) {
    return <Navigate to="/home" />;
  }

  return (
    <PageLayout title={intl.formatMessage({ defaultMessage: "Баланс" })}>
      <Balance />
    </PageLayout>
  );
}
